import { render } from "./QuestSmall.vue?vue&type=template&id=cf6f3ef4&scoped=true"
import script from "./QuestSmall.vue?vue&type=script&lang=js"
export * from "./QuestSmall.vue?vue&type=script&lang=js"

import "./QuestSmall.vue?vue&type=style&index=0&id=cf6f3ef4&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf6f3ef4"]])

export default __exports__